import React from 'react';
import './Button.css';

/**
 * SecondaryButton Component
 * Standardized secondary/outline button
 * 
 * @param {function} onClick - Click handler
 * @param {ReactNode} children - Button content
 * @param {string} size - Button size: 'small'|'medium'|'large' (default: 'medium')
 * @param {boolean} disabled - Disabled state
 * @param {string} className - Additional CSS classes
 * @param {string} variant - Button variant: 'secondary'|'outline' (default: 'outline')
 */
const SecondaryButton = ({ 
  onClick, 
  children, 
  size = 'medium', 
  disabled = false, 
  className = '',
  variant = 'outline'
}) => {
  const sizeClass = size === 'large' ? 'btn-large' : size === 'small' ? 'btn-small' : '';
  const variantClass = variant === 'secondary' ? 'btn-secondary' : 'btn-outline';
  
  return (
    <button
      className={`btn ${variantClass} ${sizeClass} ${className}`.trim()}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default SecondaryButton;














